export const global_height_breakpoint_md = {
  "name": "--pf-v5-global--height-breakpoint--md",
  "value": "40rem",
  "var": "var(--pf-v5-global--height-breakpoint--md)"
};
export default global_height_breakpoint_md;